module.exports = __webpack_public_path__ + "static/media/2DGACM16.26d2171f.jpg";